import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandVoice, BackendMutationUpdateBrandVoiceArgs } from 'src/types/backend';

import { FRAGMENT_BRAND_VOICE } from './schema';

const MUTATION = gql`
  mutation UpdateBrandVoice($id: ID!, $name: String!, $language: String) {
    updateBrandVoice(id: $id, name: $name, language: $language) {
      ...BrandVoice
    }
  }
  ${FRAGMENT_BRAND_VOICE}
`;

type Variables = BackendMutationUpdateBrandVoiceArgs;
type Result = Pick<BackendBrandVoice, 'id' | 'name' | 'language'>;

export const updateBrandVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
